export var UnrealisedCashFXGainOrLossType;
(function (UnrealisedCashFXGainOrLossType) {
    UnrealisedCashFXGainOrLossType["UnrealisedCashFXGain"] = "UnrealisedCashFXGain";
    UnrealisedCashFXGainOrLossType["UnrealisedCashFXLoss"] = "UnrealisedCashFXLoss";
    UnrealisedCashFXGainOrLossType["UnrealisedCashFXUnwindGain"] = "UnrealisedCashFXUnwindGain";
    UnrealisedCashFXGainOrLossType["UnrealisedCashFXUnwindLoss"] = "UnrealisedCashFXUnwindLoss";
})(UnrealisedCashFXGainOrLossType || (UnrealisedCashFXGainOrLossType = {}));
export var UnrealisedCashFXGainOrLossActionType;
(function (UnrealisedCashFXGainOrLossActionType) {
    UnrealisedCashFXGainOrLossActionType["UnrealisedCashFXGainOrLossCreated"] = "UnrealisedCashFXGainOrLossCreated";
})(UnrealisedCashFXGainOrLossActionType || (UnrealisedCashFXGainOrLossActionType = {}));
//# sourceMappingURL=index.js.map